import React from 'react';
import { history } from 'state/store';
import { ControlsBack, ControlsClose, ControlsContainer } from './LoginForm.styles';

const FormNavigation = (props: { isModal?: boolean; canGoBack?: boolean; onBack?: () => void }) => {
  const { isModal, canGoBack, onBack } = props;

  return (
    <ControlsContainer>
      {canGoBack && <ControlsBack onClick={onBack} />}
      {isModal && <ControlsClose onClick={() => history.push({ hash: '' })} />}
    </ControlsContainer>
  );
};

export default FormNavigation;
